<template>
	<div v-if="showBanner" class="cookie-banner">
		<div class="cookie-banner-content">
			<p>{{ $t("$cookieBanner.message") }}</p>
			<div class="cookie-banner-actions">
				<v-btn class="mr-2" color="secondary" @click="acceptCookies">
					{{ $t("$cookieBanner.accept") }}
				</v-btn>
				<v-btn color="secondary" @click="declineCookies">
					{{ $t("$cookieBanner.decline") }}
				</v-btn>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "CookieBanner",
	data() {
		return {
			showBanner: false,
		};
	},
	created() {
		const analyticsConsent = localStorage.getItem("analyticsConsent");
		if (analyticsConsent === null) {
			this.showBanner = true;
		}
	},
	methods: {
		acceptCookies() {
			localStorage.setItem("analyticsConsent", "true");
			this.showBanner = false;
			this.$loadAnalytics();
			window.location.reload();
		},
		declineCookies() {
			localStorage.setItem("analyticsConsent", "false");
			this.showBanner = false;
		},
	},
};
</script>

<style scoped>
.cookie-banner {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(255, 255, 255, 0.95);
	box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
	padding: 20px;
	z-index: 9999;
	display: flex;
	justify-content: center;
	animation: slide-up 0.5s ease-out;
}

@keyframes slide-up {
	from {
		transform: translateY(100%);
	}
	to {
		transform: translateY(0);
	}
}

.cookie-banner-content {
	max-width: 800px;
	text-align: center;
}

.cookie-banner-content p {
	font-size: 16px;
	color: #333;
	margin-bottom: 10px;
}

.cookie-banner-actions {
	margin-top: 10px;
}
</style>
